export const _DEV_ENV = !['production', 'staging'].includes(
  process.env.ENV ?? '',
)

export const devLog = (message: string, ...args: unknown[]) => {
  if (_DEV_ENV) {
    console.debug(message, ...args)
  }
}
